"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : PAGINATION : NUMBERED : STYLES --------------- ++++++++++ */


var _default = {
  numberedpagination: {
    '& .navblock': {
      background: _index.theme.color.light.light.swatch,
      border: (0, _index.replacePXinStringWithEM)('#ECF0F7 1px solid'),
      color: _index.theme.color.supporting.dark.swatch,
      cursor: 'pointer',
      fontSize: (0, _index.pxToEm)(20),
      borderRadius: (0, _index.pxToEm)(4),
      display: 'inline-flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      marginLeft: (0, _index.pxToEm)(5),
      height: (0, _index.pxToEm)(46),
      width: (0, _index.pxToEm)(46),
      marginBottom: (0, _index.pxToEm)(7),
      transition: 'all .15s linear 0s',
      '&.next, &.pagenumber': {
        marginLeft: (0, _index.pxToEm)(5)
      },
      '&:hover': {
        filter: 'brightness(95%)'
      },
      '&.disabled': {
        '&-true': {
          // background: convertHexToRGB(theme.color.supporting.dark.swatch, 2),
          color: _index.theme.color.grey.medium.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      },
      '&.current': {
        '&-true': {
          background: (0, _index.convertHexToRGB)(_index.theme.color.primary.xlight.contrast, 9),
          borderColor: _index.theme.color.primary.xlight.swatch,
          color: _index.theme.color.primary.xlight.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      }
    },
    '& .status': {
      display: 'block',
      textAlign: 'center',
      marginBottom: (0, _index.pxToEm)(20),
      fontSize: (0, _index.pxToEm)(18),
      '& .total': {
        fontWeight: '700'
      }
    },
    '& .navigation': {
      justifyContent: 'center',
      display: 'flex',
      flexWrap: 'wrap'
    }
  }
};
exports.default = _default;